import React from 'react'
import './cantine.css'

const Labs = () => {
    return (
        <div>
            zenith is here with the Cantine
        </div>
    )
}

export default Labs